import { WSButton, WSText } from "@wingspanhq/fe-component-library";
import {
  Currency,
  PayoutDestinationSummaryType,
  PayoutSummary
} from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React, { ReactNode } from "react";
import { openInNewTab } from "../../../shared/utils/openInNewTab";

export const payoutDestinationLabel = (payout: PayoutSummary): string => {
  const suffix = payout.destination?.last4
    ? ` (${payout.destination.last4})`
    : "";

  switch (payout.destination?.type) {
    case PayoutDestinationSummaryType.INTERNAL_ACCOUNT:
      return "Wingspan Wallet";
    case PayoutDestinationSummaryType.TAX_WITHHOLDING:
      return "Tax Withholding";
    case PayoutDestinationSummaryType.EXTERNAL_BANK_ACCOUNT:
      return `${payout.destination.brand || "Bank account"}${suffix}`;
    case PayoutDestinationSummaryType.PAYMENT_CARD:
      return `${payout.destination.brand || "Debit"}${suffix}`;
    case PayoutDestinationSummaryType.CHECK:
      return "Check";
    case PayoutDestinationSummaryType.GIFT_CARD:
      return "Gift card";
    default:
      return "Paid out";
  }
};

// TODO(WIN-16060): restore a "View payout" link once `PayoutSummary` carries an
//   aggregate reference. `PayoutSummary.id` is the summary's own identity, not a
//   `GET /v3/payments/payouts/:payoutId` id, so any link built from it 404s.
export function payoutToTotals(
  payout: PayoutSummary,
  currency: Currency
): [ReactNode, ReactNode] {
  const amount = formatMoney(
    payout.amount,
    (payout.currency as Currency) || currency
  );
  const redemptionUrl = payout.destination?.redemptionUrl;

  if (
    payout.destination?.type === PayoutDestinationSummaryType.GIFT_CARD &&
    redemptionUrl
  ) {
    return [
      <WSButton.Link
        key="left"
        size="S"
        rightIcon="open-tab"
        onClick={() => {
          openInNewTab(redemptionUrl);
        }}
      >
        Redeem gift card
      </WSButton.Link>,
      amount
    ];
  }

  return [
    <WSText key="left" color="gray500">
      {payoutDestinationLabel(payout)}
    </WSText>,
    amount
  ];
}
